import React from "react";
import "./assets/css/fontawesome.css";
import "./assets/css/solid.css";
import "./assets/css/regular.css";
import "./assets/css/brands.css";
import { v6 } from "./Library.v6.js";

const ignoredNames = ["OK"];

const getIconName = (name) => {
  if (`${name}`.startsWith("fa-")) {
    return name;
  }
  if (!v6.includes(name) && !ignoredNames.includes(name)) {
    console.warn(
      `"${name}" is not a valid fontawesome v6 icon name. Replace it using the v6 equivalent as the icon might not be displayed correctly.`,
      "Migration guide for 4.7 icons: https://fontawesome.com/docs/web/setup/upgrade/upgrade-from-v4"
    );
  }
  return `fa-solid fa-${name}`;
};

const Icon = ({
  name,
  fixedWidth = false,
  pulse = false,
  size,
  className: classNameFromProps,
  style: styleFromProps = {},
  ...props
}) => {
  const icon = getIconName(name);
  const className = [
    "fa",
    "icon",
    icon,
    classNameFromProps,
    fixedWidth && "fa-fw",
    pulse && "fa-pulse",
    size && `fa-${size}`,
  ]
    .filter((i) => !!i)
    .join(" ");
  const style = Object.assign(
    { animationIterationCount: "500", animationDuration: "800ms" },
    styleFromProps
  );
  return <span className={className} style={style} {...props} />;
};
Icon.displayName = "Icon.Library";
export default Icon;
